export default __webpack_public_path__ + "static/media/ephone-pos.71552555.png";